import authenticationRoutes from "./authentication/routes";
import campaignRoutes from "./campaigns/routes";

let routes = [];
routes = routes.concat(authenticationRoutes);
routes = routes.concat(campaignRoutes);
export default routes;